import React from 'react'

const Image = ({src, alt, width="" , height=""}) => {
  return (
    <img src={src} alt={alt} className="img-fluid" width={width} height={height} />
  )
}

export default Image